export const ButtonType = {
    SUBMIT: 'submit',
    RESET: 'reset',
    BUTTON: 'button',
};

export  const SalesChanelType = {
    BCA: "BCA"
}

export type AvoEventTypes = 
    | "add_extra_card_link_click"
    | "add_shipping_info"
    | "add_payment_info"
    | "add_to_cart"
    | "button_click"
    | "form_submit"
    | "link_click"
    | "select_item"
    | "select_click"
    | "selectable_click"
    | "toggle_click"
    | "form_start"
    | "form_error"
    | "order_change"
    | "click"
    | "close_overlay"
    | "element_click"
    | "datepickerClick"
    | "checkbox_click"

